import { render, staticRenderFns } from "./pretest.vue?vue&type=template&id=7f16ed28&scoped=true"
import script from "./pretest.vue?vue&type=script&lang=js"
export * from "./pretest.vue?vue&type=script&lang=js"
import style0 from "./pretest.vue?vue&type=style&index=0&id=7f16ed28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f16ed28",
  null
  
)

export default component.exports